var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnDeleteComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20741",
    "data-name": "Grupo 20741",
    transform: "translate(-1572.5 -278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(1572.5 278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_248",
    "data-name": "Elipse 248",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#d30f3c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 16.5,
    rx: 16.5,
    ry: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 16.5,
    rx: 16,
    ry: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16214",
    "data-name": "Grupo 16214",
    transform: "translate(6.964 5.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_264_-_Contorno",
    "data-name": "Rect\\xE1ngulo 264 - Contorno",
    d: "M1.365,1.365V15.02H13.654V1.365H1.365M1.365,0H13.654A1.365,1.365,0,0,1,15.02,1.365V15.02a1.365,1.365,0,0,1-1.365,1.365H1.365A1.365,1.365,0,0,1,0,15.02V1.365A1.365,1.365,0,0,1,1.365,0Z",
    transform: "translate(1.502 4.779)",
    fill: "#d30f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_265_-_Contorno",
    "data-name": "Rect\\xE1ngulo 265 - Contorno",
    d: "M1.365,1.365V2.731h15.02V1.365H1.365M1.365,0h15.02A1.365,1.365,0,0,1,17.75,1.365V2.731A1.365,1.365,0,0,1,16.385,4.1H1.365A1.365,1.365,0,0,1,0,2.731V1.365A1.365,1.365,0,0,1,1.365,0Z",
    transform: "translate(0.136 2.048)",
    fill: "#d30f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_266_-_Contorno",
    "data-name": "Rect\\xE1ngulo 266 - Contorno",
    d: "M1.365,1.365v.683h4.1V1.365h-4.1M1.365,0h4.1A1.365,1.365,0,0,1,6.827,1.365v.683A1.365,1.365,0,0,1,5.462,3.414h-4.1A1.365,1.365,0,0,1,0,2.048V1.365A1.365,1.365,0,0,1,1.365,0Z",
    transform: "translate(5.598)",
    fill: "#d30f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_117",
    "data-name": "L\\xEDnea 117",
    d: "M-.317,9.329A.683.683,0,0,1-1,8.646V-.317A.683.683,0,0,1-.317-1a.683.683,0,0,1,.683.683V8.646A.683.683,0,0,1-.317,9.329Z",
    transform: "translate(5.222 9.013)",
    fill: "#d30f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_118",
    "data-name": "L\\xEDnea 118",
    d: "M-.317,9.329A.683.683,0,0,1-1,8.646V-.317A.683.683,0,0,1-.317-1a.683.683,0,0,1,.683.683V8.646A.683.683,0,0,1-.317,9.329Z",
    transform: "translate(9.194 9.013)",
    fill: "#d30f3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_119",
    "data-name": "L\\xEDnea 119",
    d: "M-.317,9.329A.683.683,0,0,1-1,8.646V-.317A.683.683,0,0,1-.317-1a.683.683,0,0,1,.683.683V8.646A.683.683,0,0,1-.317,9.329Z",
    transform: "translate(13.167 9.013)",
    fill: "#d30f3c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDeleteComplete);
export default __webpack_public_path__ + "static/media/btn-delete-complete.f7d9a4bd9e194db52d694a8f0e6b0ff0.svg";
export { ForwardRef as ReactComponent };